/**
 * VoiceConfirmModal - Confirmacao Comando de Voz/Texto - extraído VERBATIM de ProductsContent.js (Fase 2 refactor).
 * Recebe estado/handlers via props do closure de ProductsContent.
 */
import React from 'react';
import { Check, Sparkles } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';

const VoiceConfirmModal = ({
  showVoiceConfirmModal,
  setShowVoiceConfirmModal,
  voiceCommandResult,
  setVoiceCommandResult,
  voiceCommandLoading,
  executeVoiceCommand,
  products,
}) => {
  return (
      <Dialog open={showVoiceConfirmModal} onOpenChange={setShowVoiceConfirmModal}>
        <DialogContent className="bg-gray-900 border-gray-800 max-w-lg">
          <DialogHeader>
            <DialogTitle className="text-white text-xl flex items-center gap-2">
              <Sparkles size={24} className="text-purple-400" />
              Confirmar Ação
            </DialogTitle>
          </DialogHeader>
          
          {voiceCommandResult && (
            <div className="space-y-4">
              {/* Comando original */}
              <div className="bg-gray-800/50 rounded-lg p-3">
                <p className="text-xs text-gray-500 mb-1">Seu comando:</p>
                <p className="text-white">&quot;{voiceCommandResult.original_command}&quot;</p>
              </div>
              
              {/* Ação interpretada */}
              <div className="bg-purple-500/10 border border-purple-500/30 rounded-lg p-4">
                <p className="text-purple-300 font-medium text-lg">
                  {voiceCommandResult.confirmation_message}
                </p>
              </div>
              
              {/* Produtos afetados */}
              {voiceCommandResult.products?.length > 0 && (
                <div className="space-y-2">
                  <p className="text-sm text-gray-400">Produtos afetados:</p>
                  <div className="max-h-40 overflow-y-auto space-y-1">
                    {voiceCommandResult.products.map((p, idx) => (
                      <div key={idx} className="flex justify-between items-center bg-gray-800/30 rounded px-3 py-2 text-sm">
                        <span className="text-white">{p.name}</span>
                        <span className="text-gray-400">
                          {voiceCommandResult.action === 'update_price' && (
                            <>R$ {p.current_price?.toFixed(2)} → <span className="text-green-400">R$ {voiceCommandResult.changes?.price?.toFixed(2)}</span></>
                          )}
                          {voiceCommandResult.action === 'toggle_availability' && (
                            <span className={voiceCommandResult.changes?.available ? 'text-green-400' : 'text-red-400'}>
                              {voiceCommandResult.changes?.available ? 'Ativar' : 'Desativar'}
                            </span>
                          )}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              
              {/* Botões de ação */}
              <div className="flex gap-3 pt-2">
                <button
                  onClick={() => {
                    setShowVoiceConfirmModal(false);
                    setVoiceCommandResult(null);
                  }}
                  className="flex-1 px-4 py-2.5 text-gray-400 hover:text-white border border-gray-700 rounded-lg transition-colors"
                >
                  Cancelar
                </button>
                <button
                  onClick={executeVoiceCommand}
                  disabled={voiceCommandLoading}
                  className="flex-1 px-4 py-2.5 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
                >
                  {voiceCommandLoading ? (
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  ) : (
                    <>
                      <Check size={18} />
                      Confirmar
                    </>
                  )}
                </button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

  );
};

export default VoiceConfirmModal;
